/**
 * ./exercise3/Exercise3.js
 * 
 * This module serves as the **entry page** for Exercise 3. 
 * It introduces the exercise and provides a **curtain animation effect** before allowing 
 * users to proceed to the **exercise introduction page**.
 *
 */


import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // useNavigate instead of useHistory
import "./Exercise3.css";
import Curtain from "../components/Curtain"; // Import the reusable Curtain component
import doublewordIcon from "./icons/DoublewordIcon.svg"; // Import the person icon
import { API_BASE_URL } from "../config";

const Exercise3 = () => {
  const [isCurtainActive, setIsCurtainActive] = useState(true);
  const [isExiting, setIsExiting] = useState(false);
  const navigate = useNavigate(); // Create a navigate function for navigation
  const [userData, setUserData] = useState(null); // We added this

  // We added this
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/user/me`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        });
        const data = await response.json();
        setUserData(data);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    fetchUserData();
  }, []);

  useEffect(() => {
    // Timer for curtain
    const curtainTimer = setTimeout(() => {
      setIsCurtainActive(false);
    }, 2000);

    // Timer for auto navigation
    // const navigationTimer = setTimeout(() => {
    //   setIsExiting(true);
    //   setTimeout(() => {
    //     navigate("/exercise3intro");
    //   }, 0);
    // }, 3000);

    // Cleanup both timers
    return () => {
      clearTimeout(curtainTimer);
    };
  }, [navigate]);

  return (
    <div className={`exercise3-page ${isExiting ? "fade-out" : ""}`}>
      {/* Display the curtain and set it to "disappear" */}
      {isCurtainActive && <Curtain disappear={true} duration={2000} />}

      {/* Text content */}
      <div className="exercise3-header">
        <h1>Exercise 3: Double-Word Association</h1>
      </div>

      {/* Blue bottom area */}
      <div className="exercise3-bottom">
        <img
          className="exercise3-icon"
          src={doublewordIcon}
          alt="DoublewordIcon"
        />
        <button
          className="start-exercise"
          onClick={() => {
            if (userData.exercisesUnlocked[2] >= 1) {
              navigate("/exercise3intro");
            } else {
              navigate("/Warmupwelcome", { state: { exerciseNumber: 3} });
            }
            setIsExiting(true);
          }}
        >
          <b>START</b>
        </button>
      </div>
    </div>
  );
};

export default Exercise3;
